import React from 'react';

const JobFilters = ({
  searchTerm,
  setSearchTerm,
  department,
  setDepartment,
}) => {
  return (
    <div className="job-filters">
      <div className="job-filters__search">
        <span aria-hidden="true">⌕</span>

        <input
          type="search"
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
          placeholder="Search positions..."
          aria-label="Search positions"
        />
      </div>

      <label className="job-filters__select">
        <span className="sr-only">Filter by department</span>

        <select
          value={department}
          onChange={(event) => setDepartment(event.target.value)}
        >
          <option value="All">All departments</option>
          <option value="Backend">Backend</option>
          <option value="Frontend">Frontend</option>
          <option value="QA">QA</option>
          <option value="DevOps">DevOps</option>
          <option value="Design">Design</option>
        </select>
      </label>
    </div>
  );
};

export default JobFilters;